import { TagManagerWrapper } from '.';

// Subclass for GTM
export class GTMWrapper extends TagManagerWrapper {
  constructor(dataLayerName = 'gtmLayer', gtagFunctionName = 'gtmTag') {
    super(dataLayerName, gtagFunctionName, 'gtm');
  }

  public initGTM(gtmId: string, customDomain = ''): void {
    if (!this.isValidId(gtmId, /^GTM-/)) {
      throw new Error('Invalid GTM ID');
    }
    this.loadGtagScript(gtmId, customDomain);
    this.gtagFunction('config', gtmId, {
      transport_url: customDomain ?? undefined,
    });
    this.initConsent();
  }
}
